import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import HeaderCenter from 'app/components/layout/HeaderCenter';
import { IActions } from 'app/types/actions';
import SportsOrgDetails from 'app/features/on-boarding/components/SportsOrgDetails';
import PersonalDetails from 'app/features/on-boarding/components/PersonalDetails';
import VerifyEmail from 'app/features/on-boarding/components/VerifyEmail';
import BankDetails from 'app/features/on-boarding/components/BankDetails';
import InviteDetails from 'app/features/on-boarding/components/InviteDetails';

import * as onBoardingActions from 'app/ducks/onboarding/actions';
import * as organisationActions from 'app/ducks/organisations/actions';
import * as authenticationActions from 'app/ducks/authentication/actions';
import * as invitationActions from 'app/ducks/invitations/actions';

import * as onBoardingSelectors from 'app/ducks/onboarding/selectors';
import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as invitationSelectors from 'app/ducks/invitations/selectors';

interface IOnboardingLayoutProps {
  awaitingUserVerification: boolean;
  hasUserCreated: boolean;
  hasUserLoggedIn: boolean;
  history: any;
  isLoading: boolean;
  loginCurrentUser: any;
  match: {
    url: string;
    params: any;
  };
  newUser: {
    email: string;
    password: string;
    fullName: string;
  };
  verificationSuccessful: boolean;
  onBoarding: any;
  connect: any;
  actions: IActions;
}

function selector(state): any {
  return {
    onBoarding: {
      ...onBoardingSelectors.getOnBoarding(state),
      teamShareUrl: onBoardingSelectors.getShareUrl(state),
    },
    organisations: {
      ...organisationSelectors.getOrganisations(state),
    },
    invitations: {
      ...invitationSelectors.getInvitations(state),
    },
    authentication: state.authentication,
    connect: state.connect,
  };
}

const actionCreators = _.merge(
  onBoardingActions,
  organisationActions,
  invitationActions,
  authenticationActions,
);

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class OnBoardingLayout extends React.Component<
  IOnboardingLayoutProps,
  {}
> {
  static defaultProps: IOnboardingLayoutProps = {
    awaitingUserVerification: undefined,
    hasUserCreated: undefined,
    hasUserLoggedIn: undefined,
    history: undefined,
    isLoading: undefined,
    loginCurrentUser: undefined,
    match: undefined,
    newUser: undefined,
    verificationSuccessful: undefined,
    onBoarding: undefined,
    actions: undefined,
    authentication: undefined,
    connect: {},
  };

  checkRoute = ({
    awaitingUserVerification,
    match,
    verificationSuccessful,
    history,
  }): void => {
    if (
      awaitingUserVerification
      && history.location.pathname !== `${match.url}/verify`
    ) {
      history.push(`${match.url}/verify`);
    } else if (
      verificationSuccessful
      && history.location.pathname !== `${match.url}/share`
      && history.location.pathname !== `${match.url}/account`
    ) {
      history.push(`${match.url}/share`);
    }
  };

  render(): React.ReactNode {
    this.checkRoute(this.props);
    let providerInfo = {};
    if (!_.isEmpty(this.props.match?.params?.provider)) {
      providerInfo = this.props.connect;
    }
    return (
      <div className="container on-boarding-app login-app m-h-100">
        <div className="row justify-content-center">
          <div className="col col-12 col-md-8 col-lg-6 col-xlg-5">
            <HeaderCenter logoLeft />
            <div className="row">
              <div className="col">
                <Route
                  exact
                  path={['/get-started', '/get-started/connect/:provider']}
                  render={(): React.ReactNode => (
                    <SportsOrgDetails
                      {...this.props}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                      connect={providerInfo}
                    />
                  )}
                />
                <Route
                  exact
                  path={['/get-started/personal', '/get-started/personal/connect/:provider']}
                  render={(): React.ReactNode => (
                    <PersonalDetails
                      {...this.props}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                      connect={providerInfo}
                    />
                  )}
                />
                <Route
                  path="/get-started/invite/:inviteToken"
                  render={(): React.ReactNode => (
                    <InviteDetails
                      {...this.props}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                      connect={providerInfo}
                    />
                  )}
                />
                <Route
                  exact
                  path={['/get-started/verify', '/get-started/verify/connect/:provider']}
                  render={(): React.ReactNode => (
                    <VerifyEmail
                      {...this.props}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                      connect={providerInfo}
                      verifyUser={this.props.actions.verifyUser}
                    />
                  )}
                />

                <Route
                  exact
                  path="/get-started/account"
                  render={(): React.ReactNode => (
                    <BankDetails
                      {...this.props}
                      {...this.props.actions}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                      connect={providerInfo}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
